import { useQuery } from '@tanstack/react-query';

import { env } from '~/lib/env';

interface ContactInfoEnabledResponse {
  enabled: boolean;
}

export function useIsContactInfoEnabled() {
  const isArtistsContactsEnabled =
    env('VITE_WMG_ARTIST_CONTACTS_ENABLED') === 'true';

  const { data, isLoading, error } = useQuery({
    queryKey: ['contact-info-enabled'],
    queryFn: async () => {
      const res = await fetch('/api/roster/contact_info_enabled');

      if (!res.ok) {
        throw new Error('Failed to fetch contact-info flag');
      }

      const json: ContactInfoEnabledResponse = await res.json();

      return json.enabled;
    },
    enabled: isArtistsContactsEnabled,
  });

  return {
    enabled: !!data,
    isLoading,
    error,
  };
}
